import { cn } from "@/lib/utils";

/**
 * Intestazione di pagina: titolo e sottotitolo, identici in tutta l'app.
 *
 * Prima ogni pagina riscriveva le stesse classi a mano: undici pagine usavano
 * un formato e tre ne usavano un altro (titolo piu' piccolo, colori diversi,
 * spaziature diverse). Ora c'e' un posto solo dove si decide com'e' fatta
 * l'intestazione, e tutte le pagine la prendono da qui.
 *
 * Uso:
 *   <PageHeader titolo="Clienti" descrizione="Gestisci il database dei tuoi clienti" />
 *   <PageHeader titolo="Portafoglio 2026" icona={<FileSpreadsheet ... />} descrizione={...} />
 */
export default function PageHeader({ titolo, descrizione, icona, testIdTitolo, className, compatto = false }) {
  return (
    <div className={cn("min-w-0", className)}>
      <h1
        className={cn(
          "font-bold font-heading text-foreground tracking-tight flex items-center gap-3",
          // compatto = per le pagine di lavoro fitte (es. Portafoglio), dove
          // serve spazio verticale per la griglia
          compatto ? "text-xl lg:text-2xl" : "text-3xl md:text-4xl"
        )}
        data-testid={testIdTitolo}
      >
        {icona}
        <span className="min-w-0">{titolo}</span>
      </h1>
      {descrizione ? (
        <p className={cn("text-muted-foreground text-sm", compatto ? "mt-0.5" : "mt-1")}>{descrizione}</p>
      ) : null}
    </div>
  );
}
